/** A labelled rule between the primary form and the alternatives beneath it. */
export function Divider({ label }: { label: string }) {
  return (
    <div className="my-6 flex items-center gap-3" aria-hidden="true">
      <span className="h-px flex-1 bg-buds-dark/10" />
      <span className="text-xs font-medium uppercase tracking-wide text-buds-muted">
        {label}
      </span>
      <span className="h-px flex-1 bg-buds-dark/10" />
    </div>
  );
}
